module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/quantum-phone-video.e52d7dbd.mp4";